// extracted by mini-css-extract-plugin
module.exports = {"filter-stack__item":"filter-content_filter-stack__item__xy13W","filter-stack":"filter-content_filter-stack__AtAkG","switch-filter":"filter-content_switch-filter__JZe8I"};